module.exports = __webpack_public_path__ + "static/media/add.ff56d3f0.svg";